import { render, staticRenderFns } from "./VideoCardForActive.vue?vue&type=template&id=b63f07bc&scoped=true&"
import script from "./VideoCardForActive.vue?vue&type=script&lang=js&"
export * from "./VideoCardForActive.vue?vue&type=script&lang=js&"
import style0 from "./VideoCardForActive.vue?vue&type=style&index=0&id=b63f07bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63f07bc",
  null
  
)

export default component.exports